import React from "react";
import "./GalleryLoadMore.css";

/**
 * Shared pagination footer for My Designs, Uploads, and similar galleries.
 */
const GalleryLoadMore = ({
  loadedCount = 0,
  totalCount = 0,
  hasMore = false,
  isLoadingMore = false,
  onLoadMore,
}) => {
  if (!hasMore && totalCount <= 0) {
    return null;
  }

  return (
    <div className="gallery-load-more">
      {totalCount > 0 && (
        <p className="gallery-load-more__count">
          Showing {loadedCount} of {totalCount}
        </p>
      )}
      {hasMore && (
        <button
          type="button"
          className="gallery-load-more__btn"
          onClick={onLoadMore}
          disabled={isLoadingMore}
        >
          {isLoadingMore ? "Loading…" : "Show more"}
        </button>
      )}
    </div>
  );
};

export default GalleryLoadMore;
